import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import { useTooltip } from "../../hooks/useTooltip";

export default function Edit({ at, tooltip, color = "black", readOnly = false }) {
  const tooltipRef = useTooltip();
  const tooltipProps = tooltip
    ? {
        "data-position": "left",
        "data-tooltip": tooltip,
        ref: tooltipRef,
      }
    : {};

  return (
    <Link to={at}>
      <i
        className={`material-icons cursor-pointer ${color}-text`}
        {...tooltipProps}
      >
        {readOnly ? 'visibility' : 'edit'}
      </i>
    </Link>
  );
}

Edit.propTypes = {
  at: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  color: PropTypes.string,
};
